import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';
import { parseWithEndTag } from './baseParser';

class BoldTagParser implements TagParser {
  tag = 'dik_aan';

  parse(text: string) {
    const endTag = 'dik_uit';
    const parsedTextResult = parseWithEndTag(text, endTag);

    return {
      html: `<span class="font-bold">${parsedTextResult.parsedText}</span>`,
      consumedLength: parsedTextResult.consumedLength,
    };
  }
}

ParserRegistry.register(new BoldTagParser());
